import React,{ useState , useEffect} from 'react';
import { useHistory } from "react-router-dom";
import FormContainer from '../components/FormContainer';
import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import { FormInput,FormComboBox, FormTitle, FormCheckbox } from '../validation/Form-Components';
import txnactivitiesdata from '../data/txnactivitiesdata';
import CusFormCheckbox from '../components/CusFormCheckbox';
import CusProgressBar from '../components/CusProgressBar';
import currencies from '../data/currencies.json';
import countriesriskdashboard from '../data/countrieswealth.json';
import service from '../services/ApiService';
import { requiredValidator,noTxnsValidator,noSgdEquTxnsValidator, othersInputValidator, reqDDLValidator, othAlphaNumValidator, transBankValidator } from '../validation/Validators';
import config from '../appconfig/config.json';
import Loading from '../components/Loading';
import CusNotification from '../components/CusNotification';
import helper from '../factory/Helper.js';
import { filterBy } from "@progress/kendo-data-query";
import CusToast from '../components/CusToast';

let fCurrencies = [];
const TxnActivities  = (props) => {
   
   let timer;
   const detailsType='2';
   const history = useHistory();
   const item = { bgcolor: "#389A6E", completed: 30 };

   const [isError,setIsError] = useState(false);
   const [errMsg, setErrMsg] = useState('');
   const [fCountries, setfCountries] = useState(countriesriskdashboard.slice());  //filtered countries

   const [response,setResponse] = useState({
        CompDtls:'',
        ApplicantDtlsMyInfo:''
   });

   const [showBizIncActTransBank, setShowBizIncActTransBank] = useState(false);
   const [showBizIncOther,setShowBizIncOther] = useState(false);
   const [showBizPayActOthDesc,setShowBizPayActOthDesc] = useState(false);
   const [showCurrOthDesc,setShowCurrOthDesc] = useState(false);
   const [showBuyersOth, setShowBuyersOth] = useState(false);
   const [showSuppliersOth,setShowSuppliersOth] = useState(false);
   const [showNoTxnsOth,setShowNoTxnsOth] = useState(false);
   const [showSgdEquTxnOth,setShowSgdEquTxnOth] = useState(false);
   const [isLoading, setIsLoading] = useState(true);  //to show api call
   const [isSaving, setIsSaving] = useState(false);
 
   const [txnActivities, setTxnActivities] = useState({
    BI1: false,
    BI2: false,
    BI3: false,
    BI4: false,
    BI5: false,
    BI6: false,
    BI7: false,
    BI8: false,
    BI9: false,
    BizIncActTrnBnk: '',
    BizIncActOthDesc:'',

    BP1:false,
    BP2:false,
    BP3:false,
    BP4:false,
    BP5:false,
    BP6:false,
    BP7:false,
    BizPayActOthDesc: '',
    AntTranMo:'',
    AntTranMonOth:'',
    AntSGDTran:'',
    AntSGDTranOth:'',

    BSG: false,
    BBN: false,
    BMY: false,
    BCN: false,
    BID: false,
    BIN: false,
    BOTH: false,
    BCountry: ''
   })
  
    useEffect(() => {
        console.log('@TxnActivities useEffect');
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
        
        window.scrollTo(0,0);

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        filterCurrencies();
        getData();

        return () => clearTimeout(timer);
    }, []);

    const filterCurrencies = () => {
        fCurrencies=[];
        fCurrencies = currencies;
        for(let currency of txnactivitiesdata.currenciesChkBox.data) {
            fCurrencies =  helper.filterArrayById(fCurrencies,currency.id);
        }
    }

    const filterData = (filter) => {
        const data = countriesriskdashboard.slice();
        return filterBy(data, filter);
    };
    
    const filterBuyersCntyChange = (event) => {
        setfCountries(filterData(event.filter));
    };

    const getData = () => {
        service.get().then( res =>{
            setIsLoading(false);
            if(res.data.isSucess){
                setResponse(res.data.model.fields.request);
                bindFormData(res.data.model.fields.request);
            }
            else{
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err=>{
            console.log('err=>',err);
            setIsLoading(false);
            showErrMsg(config.error.GetApiFailed);
        })
    }

    const bindFormData = (data) => {
  
        if(!data || !data.BizInc || !data.BizPay || !data.PaymentMode 
            || !data.Currencies || !data.AntTranMo || !data.AntSGDTran 
            || !data.MajorBuyers ||  !data.MajorSuppliers) {
                setIsLoading(false);
                return;
         }

        setShowBizPayActOthDesc(data.BizPay.BP7 === 'true'? true: false);
        setShowCurrOthDesc(data.Currencies.OTH === 'true'? true: false);
        setShowBizIncActTransBank(data.BizInc.BI8 === 'true'? true: false);
        setShowBizIncOther(data.BizInc.BI9 === 'true'? true: false);
        setShowBuyersOth(data.MajorBuyers.OTH === 'true'? true: false);
        setShowSuppliersOth(data.MajorSuppliers.OTH === 'true'? true:false);
        setShowNoTxnsOth(data.AntTranMo === 'OTH'? true:false);
        setShowSgdEquTxnOth(data.AntSGDTran === 'OTH'? true:false);
 
        setTxnActivities({
            BI1: data.BizInc.BI1 === 'true'? true: false,
            BI2: data.BizInc.BI2 === 'true'? true: false,
            BI3: data.BizInc.BI3 === 'true'? true: false,
            BI4: data.BizInc.BI4 === 'true'? true: false,
            BI5: data.BizInc.BI5 === 'true'? true: false,
            BI6: data.BizInc.BI6 === 'true'? true: false,
            BI7: data.BizInc.BI7 === 'true'? true: false,
            BI8: data.BizInc.BI8 === 'true'? true: false,
            BI9: data.BizInc.BI9 === 'true'? true: false,
            BizIncActTrnBnk: data.BizInc.BizIncActTrnBnk? data.BizInc.BizIncActTrnBnk : '',
            BizIncActOthDesc:data.BizInc.BizIncActOthDesc? data.BizInc.BizIncActOthDesc :'',

            BP1:data.BizPay.BP1  === 'true'? true: false,
            BP2:data.BizPay.BP2 === 'true'? true: false,
            BP3:data.BizPay.BP3 === 'true'? true: false,
            BP4:data.BizPay.BP4 === 'true'? true: false,
            BP5:data.BizPay.BP5 === 'true'? true: false,
            BP6:data.BizPay.BP6 === 'true'? true: false,
            BP7:data.BizPay.BP7 === 'true'? true: false,
            BizPayActOthDesc: data.BizPay.BizPayActOthDesc? data.BizPay.BizPayActOthDesc: '',
 

            AntTranMo:data.AntTranMo!=='OTH'?getObjInArray(data.AntTranMo,txnactivitiesdata.noOfTxnsDDL.data):getObjInArray('NTOTH',txnactivitiesdata.noOfTxnsDDL.data),
            AntTranMonOth:data.AntTranMoValue,
            AntSGDTran:data.AntSGDTran!=='OTH'?getObjInArray(data.AntSGDTran,txnactivitiesdata.sgdEquivalentTxnDDL.data):getObjInArray('AVOTH',txnactivitiesdata.sgdEquivalentTxnDDL.data),
            AntSGDTranOth:data.AntSGDTranValue,

            BSG: data.MajorBuyers.SG === 'true'? true: false,
            BBN: data.MajorBuyers.BN === 'true'? true: false,
            BMY: data.MajorBuyers.MY === 'true'? true: false,
            BCN: data.MajorBuyers.CN === 'true'? true: false,
            BID: data.MajorBuyers.ID === 'true'? true: false,
            BIN: data.MajorBuyers.IN === 'true'? true: false,
            BOTH: data.MajorBuyers.OTH === 'true'? true: false,
            BCountry: data.MajorBuyers.Country? getObjInArray(data.MajorBuyers.Country, countriesriskdashboard):null
        })
    }
   
    const getObjInArray = (iValue, array) => {
        const result = array.find( ({ value }) => value === iValue);
        return result;
    }
    const handleSubmit = (event) =>{
     
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
        
        
        if(event.isValid){
            let data = JSON.parse(JSON.stringify(event.values));
            saveTxnActivities(formatJsonParams(data));
        }
    }

    let formatJsonParams = function(data) {
        let params = {
            BizInc: {
                BI1: data.BI1,
                BI2: data.BI2,
                BI3: data.BI3,
                BI4: data.BI4,
                BI5: data.BI5,
                BI6: data.BI6,
                BI7: data.BI7,
                BI8: data.BI8,
                BI9: data.BI9,
                BizIncActTrnBnk: data.BI8? data.BizIncActTrnBnk:'',
                BizIncActOthDesc: data.BI9? data.BizIncActOthDesc:'',
            },
            BizPay:{
                BP1:data.BP1,
                BP2:data.BP2,
                BP3:data.BP3,
                BP4:data.BP4,
                BP5:data.BP5,
                BP6:data.BP6,
                BP7:data.BP7,
                BizPayActOthDesc: data.BP7? data.BizPayActOthDesc:''
            },
            AntTranMo:isAntTranMonOth(data.AntTranMo)? 'OTH':data.AntTranMo.value,
            AntTranMoValue:isAntTranMonOth(data.AntTranMo)? data.AntTranMonOth: data.AntTranMo.label,
            AntSGDTran:isAntSGDTranOth(data.AntSGDTran)? 'OTH':data.AntSGDTran.value,
            AntSGDTranValue:isAntSGDTranOth(data.AntSGDTran)? data.AntSGDTranOth: data.AntSGDTran.label,
            MajorBuyers:{
                SG: data.BSG,
                BN: data.BBN,
                MY: data.BMY,
                CN: data.BCN,
                ID: data.BID,
                IN: data.BIN,
                OTH: data.BOTH,
                Country: data.BOTH? data.BCountry.value : null
            }
        }
        return params;
    }

    const isAntTranMonOth = (obj) => {
        if(obj.value === 'NTOTH') {
            return true;
        }
        else {
            return false;
        }
    }

    const isAntSGDTranOth = (obj) => {
        if(obj.value === 'AVOTH') {
            return true;
        }
        else {
            return false;
        }
    }

    const validateNoOfCheckedBox = (data, min, max) => {
       let result = true;
       let count = 0;
       let dataArray =  Object.values(data);
    
       for(let i in dataArray){
           if(dataArray[i] === true){
                count++;
           }
       }

       if( count < min || count > max){
            result = false;
       }
       else{
           result = true;
       }
       
       return result;
    }

    const saveTxnActivities = (params) => {

        if(!validateNoOfCheckedBox(params.BizInc,1,9)){
            showErrMsg(txnactivitiesdata.incomeChkbox.header+": "+config.error.SelectChk1orMore);
            return;
        }
        if(!validateNoOfCheckedBox(params.BizPay,1,7)){
            showErrMsg(txnactivitiesdata.paymentsChkBox.header+": "+config.error.SelectChk1orMore);
            return;
        }
        if(!validateNoOfCheckedBox(params.MajorBuyers,1,5)){
            showErrMsg(txnactivitiesdata.buyersCountriesChkBox.header+": "+config.error.SelectChk5);
            return;
        }
 
        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess) {
                goNext();
            }      
            else {
                showErrMsg(config.error.SaveApiFailed);
            }     
        })
        .catch(err => {
            setIsSaving(false);
            console.log(err);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else { 
            //history.push(config.route.ApplicantDetails);
            const soleOrNsole = response.CompDtls.SoleorNonSole;
            if(soleOrNsole === config.bizConst.Sole) {  // Sole
         
                history.push(config.route.ApplicantDetails);
            }
            else { //Non-Sole
                
                history.push(config.route.NSApplicantDetails); 
            }
        }
    }
 
    const handleOnCurrencyChange = (v,props) => {
        if(props.id === txnactivitiesdata.currenciesChkBox.others.id){
            setShowCurrOthDesc(v);
        }
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }
 
    return(
        <div className="container-fluid">
             <div className="outerdivsubheader">
                <div className="row">
                    <div className="col-12">
                        <h2 className='welcome mb-0'>Business Account Opening<br/>SME Banking</h2>
                    </div>
                </div>
            </div>

            <FormContainer>
            <Form onSubmitClick={handleSubmit}
                    initialValues={txnActivities}
                    key={JSON.stringify(txnActivities)}
                    render={(formRenderProps) => (
                            <FormElement>
                                <fieldset>
                                <Field component={FormTitle} id={'ft1'} name={txnactivitiesdata.formContainerTitle[0].name}/>
 
                                <div className="row around-xs inputPair elementVisible" style={{ marginTop: "1rem" }}>
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="box">{txnactivitiesdata.incomeChkbox.header}</div>
                                    </div>
                                    {txnactivitiesdata.incomeChkbox.data.map((item, idx) => (
                                        <CusFormCheckbox key={idx} 
                                            id={item.id} 
                                            lblname={item.lblname} 
                                            onCheckedChange={(checkedValue,id)=>{}} /> ))}

                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{paddingTop:'10px'}}>
                                        <div style={{width:'100%'}}>
                                            <div style={{width:'8%',float:'left'}}>
                                                <Field id={txnactivitiesdata.incomeChkbox.toOtherBanks.id} name={txnactivitiesdata.incomeChkbox.toOtherBanks.id} component={FormCheckbox} disabled={false}
                                                    onChange={(e) => {
                                                        formRenderProps.onChange('BizIncActTrnBnk', { value: '' });
                                                        setShowBizIncActTransBank(e.value);
                                                    }} />
                                            </div>
                                            <div style={{width:'92%',float:'left'}}  className={'k-form-field'}>
                                                <label className={'k-checkbox-label'} >{txnactivitiesdata.incomeChkbox.toOtherBanks.lblname}</label>
                                            </div>
                                        </div>
                                        <div style={{width:'100%'}}>
                                            <div style={{width:'10%'}}><div className="box"></div></div>
                                            <div style={{paddingTop:'5px',width:'90%',float:'right'}}>
                                            <Field name={'BizIncActTrnBnk'} id={'BizIncActTrnBnk'}
                                                placeholder={'Please input bank name(s)'} maxLength={80} component={FormInput} 
                                                disabled={showBizIncActTransBank === false} validator={showBizIncActTransBank === false? '':transBankValidator} />  
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 txn-BI7-chk" >
                                        <div style={{width:'8%',float:'left'}}>
                                            <Field id={txnactivitiesdata.incomeChkbox.BI7.id} name={txnactivitiesdata.incomeChkbox.BI7.id} component={FormCheckbox} disabled={false} />
                                        </div>
                                        <div style={{width:'92%',float:'left'}}  className={'k-form-field'}>
                                             <label className={'k-checkbox-label'} >{txnactivitiesdata.incomeChkbox.BI7.lblname}</label>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6"></div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 txn-BI1-chk">
                                        <div style={{width:'8%',float:'left'}}>
                                            <Field id={txnactivitiesdata.incomeChkbox.BI1.id} name={txnactivitiesdata.incomeChkbox.BI1.id} component={FormCheckbox} disabled={false} />
                                        </div>
                                        <div style={{width:'92%',float:'left'}} className={'k-form-field'}>
                                             <label className={'k-checkbox-label'}>{txnactivitiesdata.incomeChkbox.BI1.lblname}</label>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 txn-BI1-chk">
                                        <div style={{width:'10%',float:'left'}}>
                                            <Field id={txnactivitiesdata.incomeChkbox.others.id} name={txnactivitiesdata.incomeChkbox.others.id} component={FormCheckbox} disabled={false}
                                                onChange={(e) => {
                                                    formRenderProps.onChange('BizIncActOthDesc', { value: '' });
                                                    setShowBizIncOther(e.value);
                                            }} />
                                        </div>
                                        <div style={{width:'90%',float:'left',paddingTop:'10px'}}  >
                                            <Field 
                                                id={'BizIncActOthDesc'}  name={'BizIncActOthDesc'} 
                                                placeholder={'Others'}
                                                maxLength={80}  
                                                component={FormInput} 
                                                disabled={showBizIncOther===false}
                                                validator={showBizIncOther === false? '':othAlphaNumValidator}/>
                                        </div>
                                    </div>
                                </div>

  
                                <div className="row around-xs inputPair elementVisible" style={{ marginTop: "1rem" }} >
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="box">{txnactivitiesdata.paymentsChkBox.header}</div>
                                    </div>
                                    {txnactivitiesdata.paymentsChkBox.data.map((item, idx) => (
                                        <CusFormCheckbox key={idx} 
                                            id={item.id} 
                                            lblname={item.lblname} 
                                            onCheckedChange={(checkedValue,id)=>{

                                            }}
                                            />))}
                                     <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{paddingTop:'10px'}}>
                                        <div style={{width:'10%',float:'left'}}>
                                            <Field id={txnactivitiesdata.paymentsChkBox.others.id} name={txnactivitiesdata.paymentsChkBox.others.id} component={FormCheckbox} disabled={false}
                                                onChange={(e) => {
                                                    formRenderProps.onChange('BizPayActOthDesc', { value: '' });
                                                    setShowBizPayActOthDesc(e.value);
                                            }} />
                                        </div>
                                        <div style={{width:'90%',float:'left',paddingTop:'10px'}}  >
                                            <Field 
                                                id={'BizPayActOthDesc'} name={'BizPayActOthDesc'} 
                                                placeholder={'Others'} 
                                                maxLength={80} 
                                                component={FormInput}
                                                disabled={showBizPayActOthDesc === false}
                                                validator={showBizPayActOthDesc === false? '':othAlphaNumValidator} />
                                        </div>
                                    </div>
                                
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div style={{width:'8%',float:'left'}}>
                                            <Field id={txnactivitiesdata.paymentsChkBox.BP6.id} name={txnactivitiesdata.paymentsChkBox.BP6.id} component={FormCheckbox} disabled={false} />
                                        </div>
                                        <div style={{width:'92%',float:'left'}}  className={'k-form-field'}>
                                             <label className={'k-checkbox-label'} >{txnactivitiesdata.paymentsChkBox.BP6.lblname}</label>
                                        </div>
                                    </div>
                                 </div>

                                <FieldWrapper style={{ marginTop: "2rem" }}>
                                 <div className="row around-xs inputPair elementVisible">
                                    <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div style={{width:'100%'}}>
                                            <div style={{width:'5%',float:'left'}}>{'3.'}</div>
                                            <div style={{width:'95%',float:'left',whiteSpace:'pre-line'}}>{txnactivitiesdata.noOfTxnsDDL.lblnameWOno}</div>
                                        </div>
                                     </div>
                                    <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box">
                                            <Field id={'AntTranMo'} 
                                                name={'AntTranMo'}
                                                component={FormComboBox}
                                                textField={'label'}
                                                data={txnactivitiesdata.noOfTxnsDDL.data}
                                                placeholder={'Please select'} 
                                                clearButton={false}
                                                validator={reqDDLValidator}
                                                onChange={ (e) => {
                                                    if(e.value === null){
                                                        return;
                                                    }
                                                    formRenderProps.onChange('AntTranMonOth', { value: '' });
                                                    if(e.value.value.toUpperCase() === 'NTOTH'){
                                                      setShowNoTxnsOth(true);
                                                    }
                                                    else{
                                                        setShowNoTxnsOth(false);
                                                    } }} />
                                        </div>
                                    </div>
                                </div>
                                </FieldWrapper>
                                { showNoTxnsOth? 
                                    <div className="row around-xs inputPair elementVisible">
                                   <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box" style={{paddingLeft:'5%'}}></div>
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box">
                                            <Field id={'AntTranMonOth'}
                                                name={'AntTranMonOth'} 
                                                placeholder={'Please input'} 
                                                component={FormInput} 
                                                maxLength={10}
                                                validator={ showNoTxnsOth? noTxnsValidator:''}
                                            />
                                        </div>
                                    </div>
                                </div>: null}
                             
                                <div className="row around-xs inputPair elementVisible" style={{ marginTop: "1rem" }} >
                                    <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div style={{width:'100%'}}>
                                            <div style={{width:'5%',float:'left'}}>{'4.'}</div>
                                            <div style={{width:'95%',float:'left',whiteSpace:'pre-line'}}>{txnactivitiesdata.sgdEquivalentTxnDDL.lblnameWOno}</div>
                                        </div>
                                     </div>
                                    <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <Field id={'AntSGDTran'} 
                                            name={'AntSGDTran'}
                                            component={FormComboBox}
                                            textField={'label'}
                                            data={txnactivitiesdata.sgdEquivalentTxnDDL.data}
                                            placeholder={'Please select'}
                                            clearButton={false}
                                            validator={reqDDLValidator}
                                            onChange={e => {
                                                if(e.value === null){
                                                    return;
                                                }
                                                if(e.value.value.toUpperCase() === 'AVOTH') {
                                                    setShowSgdEquTxnOth(true);
                                                }
                                                else{
                                                    setShowSgdEquTxnOth(false);
                                                }
                                                formRenderProps.onChange('AntSGDTranOth', { value: '' });
                                            }} />
                                    </div>
                                </div>
                                {showSgdEquTxnOth? 
                                    <div className="row around-xs inputPair elementVisible">
                                   <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box" style={{paddingLeft:'5%'}}></div>
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box">
                                            <Field name={'AntSGDTranOth'} 
                                                placeholder={'Please input'} 
                                                component={FormInput} 
                                                maxLength={15}
                                                validator={showSgdEquTxnOth? noSgdEquTxnsValidator :''} />
                                        </div>
                                    </div>
                                </div> :null}
                                
                                <div className="row around-xs inputPair elementVisible" style={{ marginTop: "1rem" }} >
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="box"  id={'fstBuyersCountriesChkBox'} >{txnactivitiesdata.buyersCountriesChkBox.header}</div>
                                    </div>
                                    {txnactivitiesdata.buyersCountriesChkBox.data.map((item, idx) => (
                                        <CusFormCheckbox key={idx} 
                                            id={item.id} 
                                            lblname={item.lblname} 
                                            onCheckedChange={(checkedValue,id)=>{ }} />))}

                                    <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{paddingTop:'10px'}}>
                                        <div style={{width:'10%',float:'left'}}>
                                            <Field id={txnactivitiesdata.buyersCountriesChkBox.others.id} name={txnactivitiesdata.buyersCountriesChkBox.others.id} component={FormCheckbox} disabled={false}
                                                onChange={(e) => {
                                                    setShowBuyersOth(e.value);
                                                    if(!e.value){
                                                        formRenderProps.onChange('BCountry', { value: '' });
                                                    }
                                            }} />
                                        </div>
                                        <div style={{width:'90%',float:'left',paddingTop:'10px'}} >
                                            <Field id={'BCountry'} 
                                                name={'BCountry'}
                                                component={FormComboBox}
                                                textField={'label'}
                                                placeholder={'Others'} 
                                                data={fCountries}
                                                filterable={true}
                                                onFilterChange={filterBuyersCntyChange}
                                                validator={showBuyersOth === false? '':reqDDLValidator}
                                                disabled={showBuyersOth === false} />
                                        </div>  
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div style={{width:'8%',float:'left'}}>
                                            <Field id={txnactivitiesdata.buyersCountriesChkBox.BCN.id} name={txnactivitiesdata.buyersCountriesChkBox.BCN.id} component={FormCheckbox} disabled={false} />       
                                        </div>
                                        <div style={{width:'92%',float:'left'}}  className={'k-form-field'}>
                                            <label className={'k-checkbox-label'}>{txnactivitiesdata.buyersCountriesChkBox.BCN.lblname}</label>
                                        </div>
                                    </div>
                                </div>
                                
                                <FieldWrapper>
                                <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} />
                                <div className="row around-xs inputPair elementVisible">
                                    <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{paddingBottom: "20px"}}>
                                        <button type={'button'} className="btn btn-back" onClick={(e) => { e.preventDefault();  history.push(config.route.AccountOpening)}}>{config.btnName.Back}</button>
                                        <button type={'submit'} className="k-button btn btn-success btn-float-right" disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                                    </div>
                                </div> 
                                </FieldWrapper>
                                
                                {/* {isError && <CusNotification msg={errMsg} closable={true} status={'error'} 
                                onClose={()=>{ setIsError(false)}} />} */}
                                <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
                                </fieldset>
                            </FormElement>
                    )}>
            </Form>
            </FormContainer>
            {isSaving && <Loading />}  
        </div>
    )

}

export default TxnActivities;